export default {
  data: () => ({
    valid: false,
  }),
  methods: {
    required(value) {
      return !!value || this.$t("validation.required");
    },
  },
  computed: {
    rules() {
      return {
        email: (value) => {
          const pattern =
            /^(([^<>()[\].,;:\s@"]+(.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+.)+[^<>()[\].,;:\s@"]{2,})$/i;
          return (
            !value || pattern.test(value) || this.$t("validation.invalidEmail")
          );
        },
        firstName: (value) => {
          const pattern = /[A-Z]{1}[a-z]+/;
          return (
            !value ||
            pattern.test(value) ||
            this.$t("validation.invalidFirstName")
          );
        },
        password: (value) =>
          (value && value.length >= 4) || this.$t("validation.invalidPassword"),
        phone: (value) => {
          let pattern =
            /^\+?\d{1,4}[\s-]?\(?\d{1,3}\)?[\s-]?\d{1,4}[\s-]?\d{1,4}[\s-]?\d{1,9}$/;
          return (
            !value ||
            pattern.test(value) ||
            this.$t("validation.invalidPhoneNumber")
          );
        },
        repeatPassword: (value, password) => {
          return (
            !value ||
            value === password ||
            this.$t("validation.invalidRepeatPassword")
          );
        },
        maxNumber: (value, number) => {
          return (
            Number(value) < number ||
            this.$t("validation.maxValue") + " " + number
          );
        },
        minNumber: (value, number) => {
          return (
            Number(value) >= number ||
            this.$t("validation.minQuantity") + " " + number
          );
        },
        minQuantity: (value) => {
          return (
            Number(value) >= 0 ||
            this.$t("validation.minQuantity")
          );
        },
        number: (value) => {
          let pattern = /^\d+\.?\d*$/;
          return (
            !value || pattern.test(value) || this.$t("validation.onlyNumber")
          );
        },
        required: (value) => !!value || this.$t("validation.required"),
        requiredArray: (value) =>
          value.length || this.$t("validation.required"),
      };
    },
  },
};
